<template lang='pug'>
  div.page-level
    h1 Hot Stove
    .embed-grid
      .embedded
        img(src="/static/RLAuOZT.gif" class="pic")
        p
          small TTTTrump's America
      .embedded
        img(src="/static/usa-trump-giant-rat.jpg" class="pic")
        p
          small NYC Welcome Home
      .embedded
        img(src="/static/hair.jpg" class="pic")
        p
          small Hairswap
      .embedded
        youtube(:video-id="'W-Q671j1MO4'" player-width="384" player-height="240")
        p
          small MOOOOOCH
      .embedded
        tweet-embed(:id="'882186896285282304'")
        p
          small WTF is this?! Sounds Hitlertastic
      .embedded
        tweet-embed(:id="'883829926993862656'")
        p
          small This is the best burn to date. Austrailia with a reality check.
      .embedded
        youtube(:video-id="'UucY6LmTkrI'" player-width="384" player-height="240")
        p
          small Bernie Busting Budgets
      .embedded
        youtube(:video-id="'FVFdsl29s_Q'" player-width="384" player-height="240")
        p
          small Great summary of this insane Presidency
      .embedded
        youtube(:video-id="'4497ZM_d3cs'" player-width="384" player-height="240")
        p
          small WH built on lies, caving in.
      .embedded
        youtube(:video-id="'RnfYF_RTEc0'" player-width="384" player-height="240")
        p
          small Strong marriage they've got there..
      .embedded
        tweet-embed(:id="'864631567972540417'")
        p
          small Turkish strongmen attack protestors in Washington, DC
      .embedded
        tweet-embed(:id="'474134260149157888'")
        p
          small Hypocritical
</template>

<script>
import Tweet from 'vue-tweet-embed'

export default {
  name: 'hotstove',
  data () {
    return {
    }
  },
  components: {
    'tweet-embed': Tweet
  }
}
</script>

<style lang='stylus'>
  .pic
    margin auto
    max-width 400px
    max-height 400px
    box-shadow 1px 1px 1px rgba(0, 0, 0, 0.4)
    border 1px solid #bababa
  .embed-grid
    display flex
    align-items center
    justify-content center
    flex-wrap wrap

  .embedded
    max-width 400px
    margin 1rem
    padding 10px
    border-radius 2px
    p
      text-align center
</style>



// WEBPACK FOOTER //
// HotStove.vue?b07d2950